export default __webpack_public_path__ + "svgs/trustpilotStarHalf-17ce70df.svg";